import type {
  Language,
  LanguageListResponse,
  Params,
  UpdateLanguageResponse,
} from '@/domains/system-management/types/language';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

export const languageApi = {
  // Get language list
  getLanguages: async (params: Params): Promise<LanguageListResponse[]> => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });
    const url = `${URLS.BACK_DSH}${APIS.languageList(queryParams.toString())}`;
    return request.get(url);
  },

  // Get language details
  getLanguage: async (tag: string): Promise<Language> => {
    const url = `${URLS.BACK_DSH}${APIS.detailLanguage(tag)}`;
    return request.get(url);
  },

  // Create language
  createLanguage: async (data: Partial<Language>): Promise<{ tag: string }> => {
    const url = `${URLS.BACK_DSH}${APIS.createLanguage}`;
    return request.post(url, data);
  },

  // Update language
  updateLanguage: async (tag: string, data: Partial<Language>): Promise<UpdateLanguageResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.updateLanguage(tag)}`;
    return request.put(url, data);
  },

  // Delete language
  deleteLanguage: async (tag: string): Promise<void> => {
    const url = `${URLS.BACK_DSH}${APIS.deleteLanguage(tag)}`;
    return request.delete(url, tag);
  },
};
